export const ALLOWED_MULTIPACK_TAGS = ['12'];
